<template>
  <div class="achievement-preview">

    <el-table
      :data="tableData"
      border
      style="width: 100%"
      class="custom-table">
      <el-table-column prop="org_name"  label="用户单位名称" align="center"> </el-table-column>
      <el-table-column prop="name"  width="100" label="用户名" align="center"> 
      </el-table-column>
      <el-table-column prop="mobile"  width="120" label="联系方式" align="center"> </el-table-column>
      <el-table-column prop="orgRecName"  width="250" label="上级推荐单位" align="center"> </el-table-column>
      <el-table-column prop="add_date"  width="120" label="注册时间" align="center"> </el-table-column>

    </el-table>
    <div class="paginBox">
      <div class="countNumber">
        共{{ total }}条
      </div>
      <div class="rightPagin">
        <el-pagination @size-change="sizePagination" @current-change="currentPagination"
          :page-size="filter.pageSize" background layout="prev, pager, next" :total="total">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'RecommendUsers',
  components: {

  },
  data() {
    return {
      total:0,
      dateValue:'',
      currentRow:{},  // 当前查看的行数据
      form:{
        name:'',
        recommend_state:'',
        updateTime:'',
        submissionTime:''
      },
      filter:{
        currPage:1,
        pageSize:8,
      },
      tableData:[],
      // 防抖定时器
      debounceTimer: null
    }
  },
  created() {
    this.getList();
  },
  methods: {
    sizePagination(e) {
      this.filter.currPage = e
      this.getList()
    },
    currentPagination(e) {
      this.filter.currPage = e
      this.getList()
    },


    getList() {
      this.$API.getMemberList(this.filter).then(res => {
        this.tableData = res.data.list;
        this.total = res.data.pageInfo.allRows;
      })
    }
  } 
}
</script>

<style lang="scss" scoped>
::v-deep .el-table th.el-table__cell{
  background: #F2F5FB !important;
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 14px;
color: #595959;

}

.countNumber {
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 14px;
color: #515A6E;
}
.paginBox {
display: flex;
justify-content: end;
padding: 0 20px 20px 0;
align-items: center;
margin-top: 20px;
width: 100%;
}

::v-deep .el-pagination.is-background .btn-prev {
background: none;
}

::v-deep .el-pagination .btn-next .el-icon {
font-size: 18px;
}

::v-deep .el-pagination .btn-prev .el-icon {
font-size: 18px;
}

::v-deep .btn-next {
width: 36px;
height: 36px;
background-color: #FFFFFF !important;
border-radius: 3px 3px 3px 3px;
border: 1px solid #E5E5E5;
}

::v-deep .btn-prev {
width: 36px;
height: 36px;
background-color: #FFFFFF !important;
border-radius: 3px 3px 3px 3px;
border: 1px solid #E5E5E5;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
background: #FFFFFF;
border-radius: 3px 3px 3px 3px;
border: 1px solid #2F86FF;
font-weight: 400;
font-size: 14px;
color: #2F86FF;
text-align: center;
font-style: normal;
text-transform: none;
}

::v-deep .el-pagination.is-background .el-pager li {
border-radius: 3px 3px 3px 3px;
border: 1px solid #B4B4B4;
background: none;
width: 36px;
height: 36px;
font-weight: 400;
font-size: 14px;
color: #313131;
text-align: center;
font-style: normal;
text-transform: none;
line-height: 35px;
}
</style>
